import { getQuestIcon } from "@/app/games/(details)/types";
import type { CampaignQuestState } from "@/components/QuestsV2/types";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { useCallback } from "react";

export const QuestBox = ({
  className,
  quest,
  backgroundMediaUrl,
  onClick,
}: {
  className: string;
  quest: CampaignQuestState;
  backgroundMediaUrl: string;
  onClick: () => void;
}) => {
  const QuestIcon = getQuestIcon(quest.type, quest.categories ?? []);
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === "Enter") onClick();
    },
    [onClick],
  );

  return (
    <div
      className={cn(
        "relative glass-container-border cursor-pointer bg-black rounded-[1.25rem]",
        className,
      )}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      // biome-ignore lint/a11y/useSemanticElements: use div instead of button as we have child elements not supported by <button>
      role="button"
      tabIndex={0}
    >
      <Image
        src={
          quest.type === "steam_wishlist"
            ? "/images/quests/steam-card.webp"
            : backgroundMediaUrl
        }
        priority={true}
        alt={quest.name}
        fill
        loading={"eager"}
        sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw"
        className={cn(
          "absolute inset-0 object-cover rounded-[calc(1.25rem-1px)]",
        )}
      />

      <div className="absolute inset-0 size-full rounded-[1.25rem] pointer-events-none bg-darken-overlay" />

      <div className="absolute left-[10%] top-[10%] text-neutral-50 font-suisse flex items-center gap-x-1.5 @4xl:flex-col @4xl:items-start">
        <QuestIcon className="@md:size-6 size-5" />
        <p className="@md:text-lg text-sm font-semibold">{quest.name}</p>
      </div>
    </div>
  );
};
